export const environment = {
  production: true,
  config: {
    dataApiUrl: 'https://api.ppm.org',
    staffApiUrl: 'https://mcapi.ppm.org',
    profilesLocationUrl: 'https://www.prayingpelicanmissions.org/tmp/upload/profiles/locations',
    googleSigninClientId: "450245815385-km5joaspbmkmrtsemm2b07o1de26df9l.apps.googleusercontent.com",
  }
};
